import { motion } from "framer-motion";

function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center bg-gray-900 p-5"
    >
      <div className="absolute inset-0 z-0 opacity-50">
        <img
          src="https://i.ibb.co/270CpZkB/toko-1.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <motion.div
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="relative z-10 text-white text-center md:w-2/5 bg-black/60 p-5 rounded-xl">
        <h2 className="text-4xl font-bold mb-10">TOKO BANGUNAN BUMI SERPONG</h2>
        <p className="text-2xl mb-10">Satu Tempat, Semua Kebutuhan Bangunan</p>
        <p className="mb-10">
          Kami menyediakan berbagai bahan bangunan, peralatan tukang,
          perlengkapan renovasi, hingga keperluan listrik. Dengan
          produk yang lengkap, harga bersaing, dan pelayanan yang cepat, kami
          siap membantu Anda membangun, merenovasi, atau menyempurnakan hunian
          maupun proyek konstruksi Anda—besar ataupun kecil.
        </p>
        <p className="mb-2">Hubungi kami disini</p>
        <div className="bg-green-500/80 p-3 rounded-2xl w-full hover:bg-green-900 transition-colors duration-300 cursor-pointer">
          <a href="#contact">Contact</a>
        </div>
      </motion.div>
    </section>
  );
}

export default Hero;
